'use strict';

var keyMirror = require('react/lib/keyMirror');

var HorizontalDragAnchors = keyMirror({
  LEFT: null,
  CENTER: null,
  RIGHT: null
});

module.exports = HorizontalDragAnchors;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/constants/HorizontalDragAnchors.js
 ** module id = 74
 ** module chunks = 0
 **/